import { Component, Input, OnChanges, SimpleChange, SimpleChanges, TemplateRef, ViewChild } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { BaseModalComponent } from 'components/modal/base-modal.component';

interface SelectableStructuralUnit {
  id: string;
  name: string;
}

@Component({
  selector: 'app-select-structural-unit-modal',
  standalone: true,
  imports: [TranslateModule],
  templateUrl: './select-structural-unit-modal.component.html',
  styleUrl: './select-structural-unit-modal.component.scss'
})
export class SelectStructuralUnitModalComponent extends BaseModalComponent implements OnChanges {
  @ViewChild('content') content!: TemplateRef<unknown>;
  @Input() isOpen: boolean = false;
  @Input() units: SelectableStructuralUnit[] = [];
  @Input() titleKey: string = 'components.structuralUnitModal.title';
  @Input() descriptionKey: string = 'components.structuralUnitModal.description';

  selectedUnitId: string | null = null;

  override ngOnChanges(changes: SimpleChanges): void {
    const isOpenChange: SimpleChange = changes['isOpen'];
    if (isOpenChange && isOpenChange.currentValue === true && isOpenChange.previousValue === false) {
      this.selectedUnitId = null;
      this.open(this.content);
    }
  }

  onConfirm(): void {
    if (!this.selectedUnitId) return;
    this.confirm.emit(this.selectedUnitId);
    this.modalService.dismissAll();
  }

  onCancel(): void {
    this.close();
  }
}
